const SceneManager = {
  current: null,
  backScene: null,
  frontScene: null,
  textScene: null,
};

export { SceneManager };
